<template>
  <div class="ls">
    <div class="header">
      <div class="contener">
        <div class="logo">
          <router-link to="/">1K Medicinal Plant Genome Database</router-link>
        </div>
        <div class="nav">
          <ul>
            <li>
              <router-link to="/contactus">Contact us</router-link>
            </li>
            <li>
              <router-link to="/vipServer">Membership service</router-link>
              <!-- <el-dropdown>
                <span class="el-dropdown-link"> 会员服务 </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="logout1"><router-link to="/blastcenter">基因序列Blast</router-link></el-dropdown-item>
                  <el-dropdown-item command="logout2"><router-link to="/gene_data_download">基因组数据下载</router-link></el-dropdown-item>
                  <el-dropdown-item command="logout3"><router-link to="/cluster_analysis">基因家族聚类分析</router-link></el-dropdown-item>
                  <el-dropdown-item command="logout4"><router-link to="/evolutionary_analysis">系统进化分析</router-link></el-dropdown-item>
                  <el-dropdown-item command="logout5"><router-link to="/contraction_and_expansion_analysis">基因家族收缩扩张分析</router-link></el-dropdown-item>
                  <el-dropdown-item command="logout6"><router-link to="/whole_gene_replication_analysis">全基因复制分析</router-link></el-dropdown-item>
                  <el-dropdown-item command="logout7"><router-link to="/circos_draw">circos作图</router-link></el-dropdown-item>
                  <el-dropdown-item command="logout8"><router-link to="/selection_pressure_analysis">选择压力分析</router-link></el-dropdown-item>
                  <el-dropdown-item command="logout9"><router-link to="/collinearity_analysis">共线性分析</router-link></el-dropdown-item>
                  <el-dropdown-item command="logout10"><router-link to="/metabolic_pathway_analysis">代谢通路分析</router-link></el-dropdown-item>
                   <el-dropdown-item command="logout11"><router-link to="/gene_cluster_analysis">代谢通路基因簇分析</router-link></el-dropdown-item>
                   <el-dropdown-item command="logout12"><router-link to="/wgcna">权重共表达分析（WGCNA)</router-link></el-dropdown-item>
                  <el-dropdown-item command="admin13"><router-link to="/vip">成为会员</router-link></el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown> -->
            </li>
          </ul>
          <div class="line1">|</div>
          <ul v-if="username == ''">
            <li>
              <router-link to="/register">Register</router-link>
            </li>
            <li>
              <router-link to="/login">Login</router-link>
            </li>
          </ul>
          <div class="user">
            <el-dropdown v-if="username != ''" @command="handleCommand">
              <span class="el-dropdown-link">
                Welcome： <span>{{ username }}</span>
                <span class="el-icon-caret-bottom mglm"></span>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="adminShow" command="admin"
                  >Subscriber management</el-dropdown-item
                >
                <el-dropdown-item command="personalCenter">My account</el-dropdown-item>
                <el-dropdown-item command="updatepwd">Reset password</el-dropdown-item>
                <el-dropdown-item command="logout">Sign out</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="top">
      <div class="center">
        <el-menu class="el-menu-demo" mode="horizontal">
          <el-menu-item index="1" v-if="username == ''">
            <router-link to="/register">注册</router-link>
          </el-menu-item>
          <el-menu-item index="2" v-if="username == ''">
            <router-link to="/login">登录</router-link>
          </el-menu-item>
          <el-menu-item index="3">
            <router-link to="/">联系我们</router-link>
          </el-menu-item>
          <el-menu-item index="3">
            <router-link to="/services">会员服务</router-link>
          </el-menu-item>
        </el-menu>
        <div class="user">
          <el-dropdown v-if="username != ''" @command="handleCommand">
            <span class="el-dropdown-link">
              Welcome： <span>{{ username }}</span>
              <span class="el-icon-caret-bottom mglm"></span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="adminShow" command="admin">用户管理</el-dropdown-item>
              <el-dropdown-item command="logout">注销登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div> -->

    <div class="line"></div>
    <div class="main">
      <router-view />
    </div>

    <div class="footer">
      Copyright © 2018 Wuhan Benagen Tech Solutions Company Limited. <span class="mlm"><a href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备2021008976号-1</a></span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Species from "./page/Species.vue";
export default {
  components: { Species },
  name: "Main",
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      username: "",
      adminShow: false,
      path:""
    };
  },
  created() {
    this.path=this.$route.path;
    ////console.log(this.$route);
    let username = localStorage.getItem("username");
    let moduleAuthorityList = JSON.parse(localStorage.getItem("moduleAuthorityList"));
    if (username != "" && username != null) {
      this.username = username;
      if(moduleAuthorityList){

      let user_manager=moduleAuthorityList.find(item=>item.moduleName=='user' && item.moduleAuthority=='manager');
       ////console.log(user_manager);
      if(user_manager!=null){
        if(user_manager.moduleAuthority=='manager'){
          ////console.log(user_manager);
          this.adminShow=true;
        }else{
          this.adminShow=false;
        }
      }else{
          this.adminShow=false;
        }

    }

    }
  },
  methods: {
    handleCommand(command) {
      let that = this;
      if (command == "logout") {
        that.$forceUpdate();
        this.$confirm("logging out…", "Notice", {
          confirmButtonText: 'Continue',
          cancelButtonText: "Cancel",
          type: "warning",
        })
          .then(() => {
            let token = localStorage.getItem("authorization");
            let that = this;
      axios
        .delete("/bena/server/gooal/user/logout", {
          headers: { Authorization: token },
        })
        .then(function (response) {
            //console.log(response);
            localStorage.clear();
            that.$router.push("/login");
          })
          .catch(function (error) {
            //console.log(error);
          });
          })
          .catch(() => {});
      }
      if (command == "admin") {
        this.$router.push("/usermanage");
      }
      if(command=="updatepwd"){
        this.$router.push("/updatepwd");
      }
      if(command=="personalCenter"){
        this.$router.push("/personalCenter");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-dropdown-menu {
  top: 45px !important;
}
.el-dropdown-menu a{
  color: #606266;
  text-decoration: none;
}
.el-dropdown-menu a:hover{
  color: seagreen;
  font-weight: bold;
}
.header {
  width: 100%;
  background: #2e8b57;
}
.header .contener {
  width: 1200px;
  margin: 0 auto;
  /* border: 1px solid red; */
  height: 70px;
}
.header .contener .line1 {
  width: 30px;
  text-align: center;
  line-height: 70px;
  color: #fff;
}
.header .contener .logo {
  line-height: 70px;

  float: left;
}
.header .contener .logo a {
  text-decoration: none;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
}
.header .contener .nav {
  float: right;
  line-height: 70px;
  display: flex;
}
.header .contener .nav ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.header .contener .nav ul li {
  float: left;
  /* width: 80PX; */
  padding: 0 10px;
  text-align: center;
}
.header .contener .nav ul li a {
  text-decoration: none;
  color: #fff;
  font-size: 14px;
}
.mlm {
  margin-left: 10px;
}
.ls {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
}
.ls .main {
  flex: 1;
  background-color: #f9f9f9;
  background: url(../assets/bg.png) no-repeat;
  background-position: bottom center;
}
.el-menu-demo.el-menu--horizontal.el-menu .el-menu-item:hover {
  color: seagreen;
}
.el-menu-demo.el-menu--horizontal.el-menu .el-menu-item a {
  text-decoration: none;
}
.top {
  width: 100%;
  height: 40px;
  background: seagreen;
  border-bottom: solid 1px #e6e6e6;
  flex: 0;
}
.top .center {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
  display: flex;
}
.top .center .el-menu-demo {
  flex: 1;
}
.top .center .user {
  width: 300px;
  /* border: 1px solid red; */
  line-height: 40px;
  color: #fff;
  font-size: 14px;
  text-align: right;
}
.top .center .user .mglm {
  margin-left: 10px;
  color: #fff;
}
.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}
.el-dropdown-menu.el-popper .el-dropdown-menu__item:hover {
  color: seagreen;
}
.top .center .el-menu-demo.el-menu--horizontal.el-menu {
  background: seagreen;
}
.top .center .el-menu.el-menu--horizontal {
  border: none;
}
.top .center .el-menu--horizontal > .el-menu-item {
  height: 40px;
  line-height: 40px;
  color: #fff;
}
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.line {
  width: 100%;
  height: 10px;
  background: #eee;
  flex: 0;
}

.footer {
  width: 100%;
  height: 45px;
  background: seagreen;
  font-size: 12px;
  text-align: center;
  line-height: 45px;
  color: #fff;
  flex: 0;
}
.footer a{
  color: unset;
  text-decoration: none;
}
</style>
